module.exports = __webpack_public_path__ + "static/img-01.7b85e2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/digital-cortex/img-01.png
// module id = 87
// module chunks = 88197199937824 128223279526715 213720915766396